// src/scales.ts
var SCALE_KEYS = [
  // Замеры карточек
  "face_heaviness",
  "jaw_tension",
  "neck_tension",
  "skin_discomfort",
  "general_tension",
  // Шесть исходных шкал семи дней (дни 1 и 7)
  "morning_energy",
  "body_stiffness",
  "tension",
  "sleep_quality",
  "post_meal_heaviness",
  "desire_to_move",
  // Серия «один признак»: беспокойство о выбранном признаке, 0–10 каждый день
  "marker_concern"
];
var SCALE_DIRECTION = {
  face_heaviness: "down",
  jaw_tension: "down",
  neck_tension: "down",
  skin_discomfort: "down",
  general_tension: "down",
  morning_energy: "up",
  body_stiffness: "down",
  tension: "down",
  sleep_quality: "up",
  post_meal_heaviness: "down",
  desire_to_move: "up",
  // Беспокойство: меньше — спокойнее. Но это не «лучше» для самого признака,
  // поэтому график серии никогда не красит его как улучшение.
  marker_concern: "down"
};
var OBS7_BASELINE_SCALES = [
  "morning_energy",
  "body_stiffness",
  "tension",
  "sleep_quality",
  "post_meal_heaviness",
  "desire_to_move"
];
function evaluateDelta(scaleKey, before, after) {
  const delta = after - before;
  if (delta === 0) return { delta, verdict: "unchanged" };
  const direction = SCALE_DIRECTION[scaleKey];
  const improved = direction === "up" ? delta > 0 : delta < 0;
  return { delta, verdict: improved ? "improved" : "worsened" };
}
var MORNING_CHECK_CHOICES = [
  "easier",
  "no_change",
  "better_then_worse",
  "heavier",
  "cannot_tell"
];
var MORNING_CHECK_CAUTION_CHOICES = [
  "better_then_worse",
  "heavier"
];

// src/events.ts
var ANALYTICS_EVENTS = [
  "start",
  "app_opened",
  "screen_opened",
  "terms_accepted",
  "safety_screen_shown",
  "safety_flag",
  "card_selected",
  "measure_before",
  "practice_opened",
  "practice_done",
  "practice_worse",
  "measure_after",
  "result_shown",
  "route_taken",
  "obs7_started",
  "obs7_day_done",
  "obs7_day_skipped",
  "obs7_completed",
  "obs7_abandoned",
  "morning_check_sent",
  "morning_check_answered",
  "p30_viewed",
  "p30_payment_started",
  "p30_paid",
  "lpf_viewed",
  "lpf_city_entered",
  "whatsapp_opened",
  "club_waitlist",
  "program_preenroll",
  "consult_requested",
  "support_opened",
  "question_asked",
  "day_logged",
  "video_started",
  "video_completed",
  "note_saved"
];
var APP_SENT_EVENTS = [
  "app_opened",
  "screen_opened",
  "practice_opened",
  "practice_done",
  "whatsapp_opened",
  "question_asked",
  "day_logged",
  "video_started",
  "video_completed",
  "note_saved"
];
var FUNNEL_STEPS = [
  { event: "start", label: "\u041E\u0442\u043A\u0440\u044B\u043B\u0438 \u0431\u043E\u0442\u0430" },
  { event: "terms_accepted", label: "\u041F\u0440\u0438\u043D\u044F\u043B\u0438 \u0433\u0440\u0430\u043D\u0438\u0446\u044B \u0441\u0435\u0440\u0432\u0438\u0441\u0430" },
  { event: "safety_screen_shown", label: "\u0423\u0432\u0438\u0434\u0435\u043B\u0438 \u0441\u043A\u0440\u0438\u043D\u0438\u043D\u0433" },
  { event: "card_selected", label: "\u0412\u044B\u0431\u0440\u0430\u043B\u0438 \u0437\u0430\u043F\u0440\u043E\u0441" },
  { event: "measure_before", label: "\u0421\u0434\u0435\u043B\u0430\u043B\u0438 \u0437\u0430\u043C\u0435\u0440 \u0434\u043E" },
  { event: "practice_done", label: "\u0412\u044B\u043F\u043E\u043B\u043D\u0438\u043B\u0438 \u043F\u0440\u043E\u0431\u0443" },
  { event: "measure_after", label: "\u0421\u0434\u0435\u043B\u0430\u043B\u0438 \u0437\u0430\u043C\u0435\u0440 \u043F\u043E\u0441\u043B\u0435" },
  { event: "result_shown", label: "\u0423\u0432\u0438\u0434\u0435\u043B\u0438 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442" },
  { event: "route_taken", label: "\u0412\u044B\u0431\u0440\u0430\u043B\u0438 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0448\u0430\u0433" }
];
var FUNNEL_OUTCOMES = [
  { event: "morning_check_answered", label: "\u0412\u0435\u0440\u043D\u0443\u043B\u0438\u0441\u044C \u043D\u0430 \u0443\u0442\u0440\u0435\u043D\u043D\u044E\u044E \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443" },
  { event: "obs7_started", label: "\u041D\u0430\u0447\u0430\u043B\u0438 \u0441\u0435\u043C\u044C \u0434\u043D\u0435\u0439" },
  { event: "obs7_completed", label: "\u0414\u043E\u0448\u043B\u0438 \u0434\u043E \u0441\u0435\u0434\u044C\u043C\u043E\u0433\u043E \u0434\u043D\u044F" },
  { event: "p30_paid", label: "\u041A\u0443\u043F\u0438\u043B\u0438" }
];
var OBSERVATION_DAYS = 7;
var PRIMARY_METRIC_EVENT = "route_taken";
var SECONDARY_METRIC_EVENT = "morning_check_answered";

// src/screens.ts
var SCREEN_IDS = [
  // Вход
  "W-01",
  // Приветствие
  "W-01A",
  // Как это работает
  "W-02",
  // Границы сервиса
  "W-03",
  // Скрининг безопасности
  "W-03A",
  // Медицинский маршрут
  "RETURN",
  // Возвращение: заменяет W-01 для прошедших карточку
  // Карточка и проба
  "S-01",
  // Выбор запроса
  "C",
  // Карточка запроса
  "C-MED",
  // Медицинский подэкран карточки
  "M-BEFORE",
  // Замер до
  "P",
  // Проба
  "M-AFTER",
  // Замер после
  "C-Q",
  // Дополнительный вопрос карточки 6
  "R",
  // Результат и маршрут
  "WORSE",
  // Стало хуже
  // Семь дней
  "O-00",
  // Описание
  "O-DAY",
  // День наблюдения
  "O-DAY-OK",
  // День сохранён
  "O-SKIP",
  // Пропуск дня
  "O-RESULT",
  // Итог семи дней
  "O-ROUTE",
  // Развилка
  "ANCHOR",
  // Сохранение опоры
  // Продукты
  "P30-01",
  "P30-PAY",
  "P30-OK",
  "LPF-01",
  "LPF-CITY",
  "LPF-WA",
  "LPF-FAR",
  "CLUB-01",
  "CLUB-PROGRAM",
  // Календарь двенадцати тем
  "CLUB-WAIT",
  "CLUB-TARIFF",
  // Выбор тарифа клуба
  "CLUB-TERMS",
  // Условия списания и согласие — пункты 5.8 и 5.9 оферты
  "CLUB-MINE",
  // Своя подписка: срок, отключение
  // Из меню и служебные
  "HOME",
  // Домашний экран: где я и что дальше
  "DAY",
  // База дня: шесть отметок о состоянии
  "DAY-LOG",
  // Мой день: неделя и календарь
  "ASK",
  // Вопрос своими словами
  "ASK-OK",
  // Вопрос отправлен
  "MORNING",
  // Утренняя проверка
  "MY-RESULT",
  "SAFETY",
  "LEGAL",
  // Документы: оферта и политика
  "LEGAL-OFFER",
  "LEGAL-PRIVACY",
  "SUPPORT",
  "SUPPORT-OK",
  "REMIND",
  "REMIND-OK",
  "ERR-PAY",
  "ERR-WA",
  "ERR-STATE"
];
var screen = (to) => ({ kind: "screen", to });
var SCREEN_MAP = {
  "W-01": [
    { button: "get_route", destination: screen("W-02"), effect: "event: start" },
    { button: "how_it_works", destination: screen("W-01A") }
  ],
  "W-01A": [
    { button: "get_route", destination: screen("W-02") },
    { button: "back", destination: screen("W-01") }
  ],
  "W-02": [
    {
      button: "understood",
      destination: screen("W-03"),
      effect: "termsAcceptedAt = now(); event: terms_accepted"
    },
    { button: "back", destination: screen("W-01") }
  ],
  "W-03": [
    {
      button: "nothing_of_this",
      destination: screen("O-DAY"),
      effect: "safetyStatus = 'clear'; \u043D\u043E\u0432\u0430\u044F \u0441\u0435\u0440\u0438\u044F \u0441\u0435\u043C\u0438 \u0434\u043D\u0435\u0439, \u0435\u0441\u043B\u0438 \u0435\u0451 \u0435\u0449\u0451 \u043D\u0435\u0442"
    },
    {
      button: "have_or_unsure",
      destination: screen("W-03A"),
      effect: "safetyStatus = 'stop_medical'; safetyEvent(screening_flag); event: safety_flag"
    }
  ],
  "W-03A": [
    {
      button: "passed_medical_check",
      destination: screen("O-DAY"),
      effect: "safetyStatus = 'clear'; safetyClearedByUserAt = now(). \u0415\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u0441\u043D\u044F\u0442\u044C \u0441\u0442\u043E\u043F-\u0441\u0442\u0430\u0442\u0443\u0441."
    },
    {
      button: "remind_in_7_days",
      destination: screen("REMIND-OK"),
      effect: "notificationSchedule(remind_7d)"
    },
    { button: "understood", destination: { kind: "close" } }
  ],
  RETURN: [
    { button: "open_my_result", destination: screen("MY-RESULT") },
    { button: "continue_observation", destination: screen("O-DAY") },
    { button: "choose_another", destination: screen("S-01") }
  ],
  "S-01": [
    {
      button: "select_card",
      destination: screen("C"),
      effect: "currentCardKey; cardSelection; event: card_selected"
    }
  ],
  C: [
    {
      button: "try_now",
      destination: screen("M-BEFORE"),
      requiresSafetyClear: true
    },
    { button: "when_doctor_needed", destination: screen("C-MED") },
    { button: "choose_another", destination: screen("S-01") }
  ],
  "C-MED": [
    { button: "back_to_card", destination: screen("C") },
    {
      button: "go_medical_route",
      destination: screen("W-03A"),
      effect: "safetyStatus = 'stop_medical'; safetyEvent(self_reported)"
    }
  ],
  "M-BEFORE": [
    {
      button: "next",
      destination: screen("P"),
      effect: "measurement(card_before); event: measure_before",
      requiresSafetyClear: true
    }
  ],
  P: [
    {
      button: "done",
      destination: screen("M-AFTER"),
      effect: "event: practice_done",
      requiresSafetyClear: true
    },
    {
      button: "got_worse",
      destination: screen("WORSE"),
      effect: "safetyEvent(practice_worse); safetyStatus = 'stop_medical'; event: practice_worse"
    }
  ],
  "M-AFTER": [
    {
      button: "show_result",
      destination: screen("R"),
      effect: "measurement(card_after); notificationSchedule(morning_check, \u0437\u0430\u0432\u0442\u0440\u0430 9:00 \u043C\u0435\u0441\u0442\u043D\u043E\u0433\u043E); event: measure_after. \u0423 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438 6 \u0441\u043D\u0430\u0447\u0430\u043B\u0430 C-Q.",
      requiresSafetyClear: true
    }
  ],
  "C-Q": [
    {
      button: "answer",
      destination: screen("R"),
      effect: "measurement(card_after, choice)"
    }
  ],
  R: [
    {
      button: "primary_route",
      destination: { kind: "route", slot: "primary" },
      effect: "event: route_taken"
    },
    {
      button: "secondary_route",
      destination: { kind: "route", slot: "secondary" },
      effect: "event: route_taken. \u0423 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438 5 \u0432\u0442\u043E\u0440\u043E\u0439 \u043A\u043D\u043E\u043F\u043A\u0438 \u043D\u0435\u0442 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u043D\u043E."
    },
    { button: "choose_another", destination: screen("S-01") }
  ],
  WORSE: [
    {
      button: "go_medical_route",
      destination: screen("W-03A"),
      effect: "safetyStatus = 'stop_medical'"
    },
    {
      button: "just_need_rest",
      destination: screen("MY-RESULT"),
      effect: "flowStatus = 'paused'. \u0412\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \xAB\u0432 \u0442\u043E\u0442 \u0436\u0435 \u0434\u0435\u043D\u044C\xBB \u043D\u0435\u0442."
    }
  ],
  "O-00": [
    {
      button: "start_free",
      destination: screen("O-DAY"),
      effect: "observationRun \u0441\u043E\u0437\u0434\u0430\u0451\u0442\u0441\u044F; event: obs7_started",
      requiresSafetyClear: true
    },
    { button: "not_now", destination: screen("REMIND") }
  ],
  "O-DAY": [
    {
      button: "done",
      destination: screen("O-DAY-OK"),
      effect: "observationDay.status = 'done'; \u0437\u0430\u043C\u0435\u0440\u044B; notificationSchedule(morning_check); event: obs7_day_done",
      requiresSafetyClear: true
    },
    {
      button: "skip_today",
      destination: screen("O-SKIP"),
      effect: "status = 'skipped'; event: obs7_day_skipped. \u0422\u0440\u0438 \u043F\u0440\u043E\u043F\u0443\u0441\u043A\u0430 \u043F\u043E\u0434\u0440\u044F\u0434 \u2192 abandoned."
    },
    {
      button: "got_worse",
      destination: screen("WORSE"),
      effect: "status = 'worse'; safetyEvent(day_worse); safetyStatus = 'stop_medical'"
    },
    {
      button: "show_result",
      destination: screen("O-RESULT"),
      effect: "\u0442\u043E\u043B\u044C\u043A\u043E \u043D\u0430 \u0434\u043D\u0435 7: run.status = 'completed'; event: obs7_completed"
    }
  ],
  "O-DAY-OK": [{ button: "ok", destination: screen("MY-RESULT") }],
  "O-SKIP": [{ button: "ok", destination: screen("MY-RESULT") }],
  "O-RESULT": [
    { button: "next_step", destination: screen("O-ROUTE") },
    { button: "save_anchor", destination: screen("ANCHOR") }
  ],
  "O-ROUTE": [
    {
      button: "new_symptom",
      destination: screen("W-03A"),
      effect: "safetyStatus = 'stop_medical'"
    },
    { button: "pain_or_history", destination: screen("LPF-01") },
    {
      button: "tolerates_practice",
      destination: screen("P30-01"),
      effect: "\u0421\u043A\u0440\u044B\u0442, \u0435\u0441\u043B\u0438 \u0437\u0430 \u0441\u0435\u043C\u044C \u0434\u043D\u0435\u0439 \u0445\u043E\u0442\u044F \u0431\u044B \u0440\u0430\u0437 \u0431\u044B\u043B \u043E\u0442\u043C\u0435\u0447\u0435\u043D \u043A\u0440\u0430\u0441\u043D\u044B\u0439 \u0444\u043B\u0430\u0433 \u2014 \u043D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E \u043E\u0442 \u0442\u043E\u0433\u043E, \u0447\u0442\u043E \u0432\u044B\u0431\u0440\u0430\u043B\u0430 \u0436\u0435\u043D\u0449\u0438\u043D\u0430.",
      requiresSafetyClear: true
    },
    { button: "not_ready", destination: screen("ANCHOR") }
  ],
  ANCHOR: [{ button: "ok", destination: screen("MY-RESULT") }],
  "P30-01": [
    { button: "start_program", destination: screen("P30-PAY"), effect: "event: p30_viewed" },
    { button: "back", destination: screen("MY-RESULT") }
  ],
  "P30-PAY": [
    {
      button: "pay",
      destination: { kind: "external", target: "payment" },
      effect: "purchase(pending); event: p30_payment_started. \u0414\u043E\u0441\u0442\u0443\u043F \u0432\u044B\u0434\u0430\u0451\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0451\u043D\u043D\u043E\u043C\u0443 \u0432\u0435\u0431\u0445\u0443\u043A\u0443, \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043F\u043E \u0444\u0430\u043A\u0442\u0443 \u0440\u0435\u0434\u0438\u0440\u0435\u043A\u0442\u0430."
    }
  ],
  "P30-OK": [{ button: "ok", destination: screen("MY-RESULT") }],
  "LPF-01": [
    { button: "book", destination: screen("LPF-CITY"), effect: "event: lpf_viewed" },
    { button: "back", destination: screen("MY-RESULT") }
  ],
  "LPF-CITY": [
    {
      button: "continue",
      destination: screen("LPF-WA"),
      effect: "bookingRequest; event: lpf_city_entered. \u0415\u0441\u043B\u0438 \u0433\u043E\u0440\u043E\u0434\u0430 \u043D\u0435\u0442 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435 \u043F\u0440\u0438\u0451\u043C\u0430 \u2014 LPF-FAR."
    }
  ],
  "LPF-WA": [
    {
      button: "open_whatsapp",
      destination: { kind: "external", target: "whatsapp" },
      effect: "event: whatsapp_opened. \u0412 WhatsApp \u0443\u0445\u043E\u0434\u0438\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0448\u0430\u0431\u043B\u043E\u043D \u0441 \u043F\u0443\u0441\u0442\u044B\u043C\u0438 \u043F\u043E\u043B\u044F\u043C\u0438: \u043E\u0442\u0432\u0435\u0442\u044B, \u0437\u0430\u043C\u0435\u0440\u044B \u0438 \u0444\u043B\u0430\u0433\u0438 \u043D\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u044E\u0442\u0441\u044F \u043D\u0438\u043A\u043E\u0433\u0434\u0430."
    },
    { button: "back", destination: screen("LPF-01") }
  ],
  "LPF-FAR": [
    { button: "notify_when_available", destination: screen("REMIND-OK") },
    { button: "start_obs7", destination: screen("O-00") }
  ],
  "CLUB-PROGRAM": [
    { button: "choose_tariff", destination: screen("CLUB-TARIFF") },
    { button: "back", destination: screen("CLUB-01") }
  ],
  "CLUB-01": [
    {
      button: "notify_on_launch",
      destination: screen("CLUB-WAIT"),
      effect: "clubWaitlistEntry; event: club_waitlist"
    },
    { button: "choose_tariff", destination: screen("CLUB-TARIFF") },
    { button: "my_subscription", destination: screen("CLUB-MINE") },
    { button: "program", destination: screen("CLUB-PROGRAM") }
  ],
  "CLUB-WAIT": [{ button: "ok", destination: screen("MY-RESULT") }],
  "CLUB-TARIFF": [{ button: "continue", destination: screen("CLUB-TERMS") }],
  /*
    Условия списания. Отсюда женщина уходит на страницу оплаты провайдера,
    а не на наш экран: подтверждение придёт вебхуком, а не редиректом.
  */
  "CLUB-TERMS": [
    { button: "pay", destination: { kind: "external", target: "payment" } },
    { button: "back", destination: screen("CLUB-TARIFF") }
  ],
  "CLUB-MINE": [
    { button: "cancel_renewal", destination: screen("CLUB-MINE") },
    { button: "back", destination: screen("CLUB-01") }
  ],
  /*
    Дом. Каждая кнопка ведёт в одно место — но какие кнопки показать,
    решает состояние: женщина в наблюдении видит «Продолжить день»,
    закончившая — «Мой результат».
  */
  HOME: [
    { button: "continue", destination: screen("O-DAY") },
    { button: "my_result", destination: screen("MY-RESULT") },
    { button: "choose_request", destination: screen("S-01") },
    { button: "ask", destination: screen("ASK") },
    { button: "day", destination: screen("DAY") }
  ],
  /*
   * База дня.
   *
   * Второй слой продукта: первый показывает, что происходит с лицом до
   * и после практики, второй — каким в этот день было всё остальное.
   * Не обязательный этап после практики и не пункт в глубине меню:
   * женщина заходит сюда сама, раз в день, на двадцать секунд.
   */
  DAY: [
    {
      button: "save",
      destination: screen("DAY-LOG"),
      effect: "dailyLog(upsert \u043F\u043E \u043C\u0435\u0441\u0442\u043D\u043E\u0439 \u0434\u0430\u0442\u0435); event: day_logged"
    },
    { button: "back", destination: screen("HOME") }
  ],
  "DAY-LOG": [
    { button: "today", destination: screen("DAY") },
    { button: "back", destination: screen("HOME") }
  ],
  /*
   * Вопрос своими словами.
   *
   * Отдельный экран, а не строка в поддержке: поддержка чинит поломки,
   * а здесь женщина рассказывает, что с ней происходит. Эти два потока
   * читают разные люди и с разной целью, и смешивать их — значит потерять
   * самое ценное содержание среди «не приходит уведомление».
   *
   * Имя и возраст спрашиваем прямо здесь: Елена разбирает вопросы вслух,
   * и «Марина, 47» — единственное, что при этом называется. Имя из Telegram
   * для этого не годится: там бывает и «Мася», и пустота.
   */
  ASK: [
    {
      button: "send",
      destination: screen("ASK-OK"),
      effect: "freeQuestion(name, age, text); event: question_asked"
    },
    { button: "back", destination: screen("HOME") }
  ],
  "ASK-OK": [{ button: "ok", destination: screen("HOME") }],
  MORNING: [
    {
      button: "answer",
      destination: screen("MY-RESULT"),
      effect: "measurement(morning_check, choice); event: morning_check_answered"
    }
  ],
  "MY-RESULT": [
    { button: "continue_observation", destination: screen("O-DAY") },
    { button: "start_over", destination: screen("S-01") }
  ],
  SAFETY: [
    {
      button: "read",
      destination: { kind: "back-to" },
      effect: "\u0415\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435 \u0440\u0430\u0437\u0440\u0435\u0448\u0451\u043D\u043D\u043E\u0435 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0438\u0437 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u043E\u0434\u043D\u043E\u0433\u043E \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F."
    }
  ],
  LEGAL: [
    { button: "offer", destination: screen("LEGAL-OFFER") },
    { button: "privacy", destination: screen("LEGAL-PRIVACY") }
  ],
  "LEGAL-OFFER": [{ button: "back", destination: screen("LEGAL") }],
  "LEGAL-PRIVACY": [{ button: "back", destination: screen("LEGAL") }],
  SUPPORT: [
    {
      button: "write_support",
      destination: { kind: "external", target: "support" },
      effect: "event: support_opened"
    }
  ],
  "SUPPORT-OK": [{ button: "ok", destination: screen("MY-RESULT") }],
  REMIND: [
    { button: "remind_7d", destination: screen("REMIND-OK") },
    { button: "remind_30d", destination: screen("REMIND-OK") }
  ],
  "REMIND-OK": [{ button: "ok", destination: screen("MY-RESULT") }],
  "ERR-PAY": [
    { button: "try_again", destination: screen("P30-PAY") },
    { button: "write_support", destination: screen("SUPPORT") }
  ],
  "ERR-WA": [
    { button: "copy_message", destination: screen("LPF-WA") },
    { button: "write_direct", destination: { kind: "external", target: "support" } }
  ],
  "ERR-STATE": [
    { button: "back_to_result", destination: screen("MY-RESULT") },
    { button: "start_over", destination: screen("S-01") }
  ]
};
var SCREENS_WITHOUT_NAV = [
  "W-01",
  "W-01A",
  "W-02",
  "W-03",
  "W-03A",
  "RETURN"
];
var SCREEN_ALLOWED_BACK_TO = "SAFETY";
var SCREEN_TITLES = {
  "W-01": "\u041F\u0440\u0438\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435",
  "W-01A": "\u041A\u0430\u043A \u044D\u0442\u043E \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442",
  "W-02": "\u0413\u0440\u0430\u043D\u0438\u0446\u044B \u0441\u0435\u0440\u0432\u0438\u0441\u0430",
  "W-03": "\u0421\u043A\u0440\u0438\u043D\u0438\u043D\u0433 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438",
  "W-03A": "\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0439 \u043C\u0430\u0440\u0448\u0440\u0443\u0442",
  RETURN: "\u0412\u043E\u0437\u0432\u0440\u0430\u0449\u0435\u043D\u0438\u0435",
  "S-01": "\u0412\u044B\u0431\u043E\u0440 \u0437\u0430\u043F\u0440\u043E\u0441\u0430",
  C: "\u041A\u0430\u0440\u0442\u043E\u0447\u043A\u0430 \u0437\u0430\u043F\u0440\u043E\u0441\u0430",
  "C-MED": "\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0439 \u043F\u043E\u0434\u044D\u043A\u0440\u0430\u043D \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438",
  "M-BEFORE": "\u0417\u0430\u043C\u0435\u0440 \u0434\u043E",
  P: "\u041F\u0440\u043E\u0431\u0430",
  "M-AFTER": "\u0417\u0430\u043C\u0435\u0440 \u043F\u043E\u0441\u043B\u0435",
  "C-Q": "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0432\u043E\u043F\u0440\u043E\u0441",
  R: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u0438 \u043C\u0430\u0440\u0448\u0440\u0443\u0442",
  WORSE: "\u0421\u0442\u0430\u043B\u043E \u0445\u0443\u0436\u0435",
  "O-00": "\u0421\u0435\u043C\u044C \u0434\u043D\u0435\u0439: \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
  "O-DAY": "\u0414\u0435\u043D\u044C \u043D\u0430\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u044F",
  "O-DAY-OK": "\u0414\u0435\u043D\u044C \u0441\u043E\u0445\u0440\u0430\u043D\u0451\u043D",
  "O-SKIP": "\u041F\u0440\u043E\u043F\u0443\u0441\u043A \u0434\u043D\u044F",
  "O-RESULT": "\u0418\u0442\u043E\u0433 \u0441\u0435\u043C\u0438 \u0434\u043D\u0435\u0439",
  "O-ROUTE": "\u0420\u0430\u0437\u0432\u0438\u043B\u043A\u0430 \u043F\u043E\u0441\u043B\u0435 \u0441\u0435\u043C\u0438 \u0434\u043D\u0435\u0439",
  ANCHOR: "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u043E\u043F\u043E\u0440\u044B",
  "P30-01": "\u0418\u043D\u0442\u0435\u043D\u0441\u0438\u0432: \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
  "P30-PAY": "\u0418\u043D\u0442\u0435\u043D\u0441\u0438\u0432: \u043E\u043F\u043B\u0430\u0442\u0430",
  "P30-OK": "\u0418\u043D\u0442\u0435\u043D\u0441\u0438\u0432: \u0434\u043E\u0441\u0442\u0443\u043F \u043E\u0442\u043A\u0440\u044B\u0442",
  "LPF-01": "\u041B\u0438\u0447\u043D\u0430\u044F \u0442\u0435\u0440\u0430\u043F\u0438\u044F: \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
  "LPF-CITY": "\u041B\u0438\u0447\u043D\u0430\u044F \u0442\u0435\u0440\u0430\u043F\u0438\u044F: \u0433\u043E\u0440\u043E\u0434",
  "LPF-WA": "\u041B\u0438\u0447\u043D\u0430\u044F \u0442\u0435\u0440\u0430\u043F\u0438\u044F: \u0437\u0430\u043F\u0438\u0441\u044C",
  "LPF-FAR": "\u041B\u0438\u0447\u043D\u0430\u044F \u0442\u0435\u0440\u0430\u043F\u0438\u044F: \u0433\u043E\u0440\u043E\u0434\u0430 \u043D\u0435\u0442",
  "CLUB-01": "\u041A\u043B\u0443\u0431: \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
  "CLUB-PROGRAM": "\u041A\u043B\u0443\u0431: \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044C \u0442\u0435\u043C",
  "CLUB-WAIT": "\u041A\u043B\u0443\u0431: \u043B\u0438\u0441\u0442 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F",
  "CLUB-TARIFF": "\u041A\u043B\u0443\u0431: \u0432\u044B\u0431\u043E\u0440 \u0442\u0430\u0440\u0438\u0444\u0430",
  "CLUB-TERMS": "\u041A\u043B\u0443\u0431: \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F",
  "CLUB-MINE": "\u041A\u043B\u0443\u0431: \u043C\u043E\u044F \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0430",
  HOME: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
  DAY: "\u0411\u0430\u0437\u0430 \u0434\u043D\u044F",
  "DAY-LOG": "\u041C\u043E\u0439 \u0434\u0435\u043D\u044C",
  ASK: "\u0412\u043E\u043F\u0440\u043E\u0441 \u0441\u0432\u043E\u0438\u043C\u0438 \u0441\u043B\u043E\u0432\u0430\u043C\u0438",
  "ASK-OK": "\u0412\u043E\u043F\u0440\u043E\u0441 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D",
  MORNING: "\u0423\u0442\u0440\u0435\u043D\u043D\u044F\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430",
  "MY-RESULT": "\u041C\u043E\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442",
  SAFETY: "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C",
  LEGAL: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
  "LEGAL-OFFER": "\u041E\u0444\u0435\u0440\u0442\u0430",
  "LEGAL-PRIVACY": "\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438",
  SUPPORT: "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
  "SUPPORT-OK": "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430: \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
  REMIND: "\u041D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F",
  "REMIND-OK": "\u041D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F: \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E",
  "ERR-PAY": "\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u043F\u043B\u0430\u0442\u044B",
  "ERR-WA": "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430 \u0432 WhatsApp",
  "ERR-STATE": "\u041D\u0435\u043F\u043E\u043D\u044F\u0442\u043D\u043E\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435"
};
function screenTitle(id) {
  return SCREEN_TITLES[id] ?? id;
}

// src/content.ts
import { z } from "zod";
var contentKey = z.string().regex(/^[a-z_]+:[a-z0-9-]+$/, {
  message: "\u041A\u043B\u044E\u0447 \u0432\u0438\u0434\u0430 \xAB\u0442\u0438\u043F:\u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\xBB, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 practice:breath-shoulders"
});
var routeTarget = z.enum(["intensive21", "lpf", "obs7"]);
var routeButton = z.object({
  label: z.string().min(1).max(60),
  target: routeTarget
});
var practiceContent = z.object({
  title: z.string().min(1).max(120),
  purpose: z.string().min(1),
  // зачем нужна
  suitableFor: z.string().min(1),
  // кому подходит
  contraindications: z.string().min(1),
  // когда не выполнять — обязательно для публикации
  startPosition: z.string().min(1),
  // исходное положение
  steps: z.array(z.string().min(1)).min(1),
  // последовательность действий
  durationSec: z.number().int().positive(),
  // длительность
  acceptableSensations: z.string().min(1),
  // допустимые ощущения
  stopCriteria: z.string().min(1),
  // когда остановиться — обязательно для публикации
  reassessAfter: z.string().min(1),
  // когда оценить повторно
  variantEasier: z.string().min(1),
  // упрощённый вариант
  variantHarder: z.string().min(1),
  // более сложный вариант
  /** Строка «остановитесь при боли, головокружении, одышке или ухудшении». */
  caution: z.string().min(1),
  /**
   * Секрет практики: то, из-за чего она работает или не работает.
   *
   * У Елены это отдельный блок в каждой пробе — «важна не сила давления,
   * а спокойный контакт». Без него женщина делает движение, но не делает
   * практику.
   */
  secret: z.string().nullable().default(null),
  videoUrl: z.string().url().nullable().default(null),
  videoCaption: z.string().nullable().default(null),
  /** Первый кадр. Без него вебвью Telegram рисует чёрный прямоугольник. */
  videoPosterUrl: z.string().url().nullable().default(null),
  /** Отношение ширины к высоте. Видео бывает и вертикальным — рамка подстраивается. */
  videoAspect: z.number().positive().nullable().default(null),
  coverUrl: z.string().url().nullable().default(null),
  /** Не показывается женщине. */
  internalNote: z.string().nullable().default(null)
});
var cardContent = z.object({
  /**
   * Он же текст кнопки в списке запросов.
   *
   * Кнопка переносит текст и растёт, а не обрезает, — но три строки это
   * предел читаемости на телефоне. Ограничение держит именно это,
   * а не ширину вёрстки.
   */
  title: z.string().min(1).max(90),
  /** Признаки узнавания. У карточки «не могу выбрать» список пустой намеренно. */
  bullets: z.array(z.string().min(1)).default([]),
  body: z.array(z.string().min(1)).min(1),
  /** «Чего из этого нельзя заключить» — одна из самых сильных частей карточки. */
  caution: z.string().min(1),
  /** «Что не делать вслепую» на экране результата. Есть не у всех карточек. */
  blind: z.string().nullable().default(null),
  scaleKey: z.enum(SCALE_KEYS),
  measureBefore: z.string().min(1),
  measureAfter: z.string().min(1),
  /** Строка над шкалой после пробы. Есть у карточки про овал и осанку. */
  afterNote: z.string().nullable().default(null),
  /** Строка на экране результата. Есть у карточки «всё сразу». */
  resultNote: z.string().nullable().default(null),
  /** Дополнительный вопрос после замера. Есть у карточки «не могу выбрать». */
  extraQuestion: z.object({
    title: z.string().min(1),
    options: z.array(z.string().min(1)).min(2)
  }).nullable().default(null),
  practiceKey: contentKey,
  medScreenKey: contentKey,
  /** Текст рекомендации перед кнопками маршрута. */
  route: z.string().min(1),
  primary: routeButton,
  /** null — второй кнопки нет. У карточки «всё сразу» это намеренно. */
  secondary: routeButton.nullable().default(null)
});
var medScreenContent = z.object({
  title: z.string().min(1),
  /** Блок «Срочно». Пустым оставлять нельзя. */
  urgent: z.array(z.string().min(1)).min(1),
  /** Блок «Планово». */
  plan: z.string().min(1),
  note: z.string().nullable().default(null)
});
var dayTask = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("scales"),
    scales: z.array(z.object({ key: z.enum(SCALE_KEYS), label: z.string().min(1) })).min(1)
  }),
  z.object({
    type: z.literal("single_choice"),
    question: z.string().min(1),
    options: z.array(z.string().min(1)).min(2),
    allowOther: z.boolean().default(false),
    followUpText: z.string().nullable().default(null)
  }),
  z.object({
    type: z.literal("multi_choice"),
    question: z.string().min(1),
    options: z.array(z.string().min(1)).min(2),
    allowOther: z.boolean().default(false)
  }),
  z.object({
    type: z.literal("free_text"),
    questions: z.array(z.string().min(1)).min(1)
  }),
  z.object({
    type: z.literal("practice"),
    practiceKey: contentKey
  }),
  z.object({
    type: z.literal("multi_measure"),
    scaleKey: z.enum(SCALE_KEYS),
    moments: z.array(z.object({ key: z.string().min(1), label: z.string().min(1) })).min(2)
  }),
  /**
   * Выбор признака на всю серию. Женщина сначала узнаёт свою ситуацию
   * (группа с примерами), затем уточняет признак своими словами — это
   * отдельное поле в ответе дня 1, а не вариант из списка.
   */
  z.object({
    type: z.literal("marker_choice"),
    question: z.string().min(1),
    options: z.array(
      z.object({
        key: z.string().min(1),
        label: z.string().min(1),
        examples: z.array(z.string().min(1)).default([]),
        /** Постоянная памятка для этой группы, например про тазовые симптомы. */
        memo: z.string().nullable().default(null)
      })
    ).min(2),
    /** Подсказка к полю «Мой признак на эти 7 дней». */
    textHint: z.string().min(1)
  }),
  /** Ссылка на другой раздел, например «Мой день». Текст и адрес задаёт содержание. */
  z.object({
    type: z.literal("link"),
    label: z.string().min(1),
    target: z.enum(["day_log"])
  })
]);
var obsDayContent = z.object({
  dayIndex: z.number().int().min(1).max(7),
  title: z.string().min(1),
  body: z.array(z.string()).default([]),
  tasks: z.array(dayTask).min(1),
  /**
   * Видео дня. Поля заполняются из «мест для видео» в панели — так же,
   * как у практик. Без них в схеме админка писала бы в пустоту, а сам
   * экран дня не показывал бы ролик вовсе.
   */
  videoUrl: z.string().url().nullable().optional(),
  videoPosterUrl: z.string().url().nullable().optional(),
  videoAspect: z.number().positive().nullable().optional(),
  videoCaption: z.string().max(200).nullable().optional()
});
var screenContent = z.object({
  overline: z.string().nullable().default(null),
  title: z.string().min(1),
  body: z.array(z.string()).default([]),
  bullets: z.array(z.string()).default([]),
  highlight: z.string().nullable().default(null),
  /**
   * Что женщина получает. Отдельно от `bullets`, потому что смысл другой:
   * bullets — из чего состоит программа, gains — что она с этого имеет.
   */
  gains: z.array(z.string().min(1)).default([]),
  /**
   * Чего не будет.
   *
   * Список с обратным знаком, и он важнее, чем кажется: женщина 45+ уже
   * пробовала «гонять жидкость» и агрессивные техники. Обещание, что этого
   * не будет, продаёт сильнее ещё одного пункта в списке достоинств.
   */
  avoids: z.array(z.string().min(1)).default([]),
  /** Мысль, с которой женщина уходит с экрана. Ставится последней. */
  closing: z.string().nullable().default(null),
  legalNote: z.string().nullable().default(null),
  videoUrl: z.string().url().nullable().default(null),
  videoCaption: z.string().nullable().default(null),
  videoPosterUrl: z.string().url().nullable().default(null),
  videoAspect: z.number().positive().nullable().default(null),
  /** Подписи кнопок. Ключи — из карты экранов; куда ведут, Елена не меняет. */
  buttons: z.record(z.string(), z.string()).default({})
});
var faqContent = z.object({
  question: z.string().min(1),
  answer: z.string().min(1),
  isVisible: z.boolean().default(true)
});
var menuContent = z.object({
  items: z.array(
    z.object({
      key: z.string().min(1),
      label: z.string().min(1).max(24),
      inMoreSheet: z.boolean().default(false),
      requiresCardPassed: z.boolean().default(false)
    })
  ).min(1)
});
var safetyScreeningContent = z.object({
  title: z.string().min(1),
  flags: z.array(z.string().min(1)).min(1),
  legalNote: z.string().min(1)
});
var programWeekContent = z.object({
  weekIndex: z.number().int().min(1).max(4),
  title: z.string().min(1),
  description: z.string().min(1)
});
var programDayContent = z.object({
  dayIndex: z.number().int().min(1).max(30),
  weekIndex: z.number().int().min(1).max(4),
  title: z.string().min(1),
  body: z.array(z.string()).default([]),
  practiceKey: contentKey
});
var CONTENT_SCHEMAS = {
  card: cardContent,
  practice: practiceContent,
  screen: screenContent,
  med_screen: medScreenContent,
  obs_day: obsDayContent,
  program_day: programDayContent,
  program_week: programWeekContent,
  faq: faqContent,
  menu: menuContent,
  safety: safetyScreeningContent
};
var PROTECTED_CONTENT_TYPES = ["med_screen", "safety"];
function parseContent(type, data) {
  return CONTENT_SCHEMAS[type].parse(data);
}
function safeParseContent(type, data) {
  return CONTENT_SCHEMAS[type].safeParse(data);
}

// src/broadcast.ts
import { z as z2 } from "zod";
var FLOW_STATUSES = [
  "new",
  "card",
  "obs7",
  "intensive21",
  "club",
  "individual",
  "medical",
  "paused"
];
var FLOW_STATUS_LABELS = {
  new: "\u0422\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u0438\u0448\u043B\u0430",
  card: "\u0412\u044B\u0431\u0440\u0430\u043B\u0430 \u0437\u0430\u043F\u0440\u043E\u0441",
  obs7: "\u041F\u0440\u043E\u0445\u043E\u0434\u0438\u0442 \u0441\u0435\u043C\u044C \u0434\u043D\u0435\u0439",
  intensive21: "\u041D\u0430 \u0438\u043D\u0442\u0435\u043D\u0441\u0438\u0432\u0435",
  club: "\u0412 \u043A\u043B\u0443\u0431\u0435",
  individual: "\u041B\u0438\u0447\u043D\u0430\u044F \u0442\u0435\u0440\u0430\u043F\u0438\u044F",
  medical: "\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0439 \u043C\u0430\u0440\u0448\u0440\u0443\u0442",
  paused: "\u041F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u043B\u0430"
};
var PRODUCT_CODES = [
  "obs7",
  "intensive21",
  "club_1",
  "club_3",
  "club_6",
  "club_12",
  "lpf"
];
var PRODUCT_LABELS = {
  obs7: "\u0421\u0435\u043C\u044C \u0434\u043D\u0435\u0439 \u043D\u0430\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u044F",
  intensive21: "\u0418\u043D\u0442\u0435\u043D\u0441\u0438\u0432 21 \u0434\u0435\u043D\u044C",
  club_1: "\u041A\u043B\u0443\u0431 \u043D\u0430 \u043C\u0435\u0441\u044F\u0446",
  club_3: "\u041A\u043B\u0443\u0431 \u043D\u0430 \u0442\u0440\u0438 \u043C\u0435\u0441\u044F\u0446\u0430",
  club_6: "\u041A\u043B\u0443\u0431 \u043D\u0430 \u043F\u043E\u043B\u0433\u043E\u0434\u0430",
  club_12: "\u041A\u043B\u0443\u0431 \u043D\u0430 \u0433\u043E\u0434",
  lpf: "\u041B\u0438\u0447\u043D\u0430\u044F \u0442\u0435\u0440\u0430\u043F\u0438\u044F"
};
var cohortFilter = z2.object({
  /** Этап пути. Пусто — любой. */
  flowStatus: z2.array(z2.enum(FLOW_STATUSES)).default([]),
  /** Источник перехода. Пусто — любой. */
  source: z2.array(z2.string().min(1).max(60)).default([]),
  /** Есть открытый доступ к любому из перечисленных продуктов. */
  hasProduct: z2.array(z2.enum(PRODUCT_CODES)).default([]),
  /** Нет открытого доступа ни к одному из перечисленных. */
  withoutProduct: z2.array(z2.enum(PRODUCT_CODES)).default([]),
  /** Заходила за последние N дней. */
  seenWithinDays: z2.number().int().min(1).max(365).nullable().default(null),
  /** Не заходила уже N дней. Главное условие для возвращающих писем. */
  notSeenForDays: z2.number().int().min(1).max(365).nullable().default(null),
  /** Пришла не раньше чем N дней назад. */
  joinedWithinDays: z2.number().int().min(1).max(365).nullable().default(null)
});
var EMPTY_COHORT = cohortFilter.parse({});
var broadcastDraft = z2.object({
  title: z2.string().min(1).max(120),
  /**
   * Предел Telegram — 4096 символов. Берём с запасом: длинное сообщение
   * в мессенджере всё равно не читают, а обрезанное на середине выглядит
   * как поломка.
   */
  body: z2.string().min(1).max(3500),
  withAppButton: z2.boolean().default(true),
  cohort: cohortFilter
});
var BROADCAST_NEVER = [
  "\u0436\u0435\u043D\u0449\u0438\u043D\u044B \u0432 \u0441\u0442\u043E\u043F-\u0441\u0442\u0430\u0442\u0443\u0441\u0435 \u043C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u043E\u0433\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430",
  "\u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0432\u0448\u0438\u0435 \u0431\u043E\u0442\u0430",
  "\u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0432\u0448\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430"
];

// src/day.ts
import { z as z3 } from "zod";
var DAY_FIELDS = [
  {
    key: "sleep",
    label: "\u0421\u043E\u043D",
    options: [
      { value: "slept", label: "\u0432\u044B\u0441\u043F\u0430\u043B\u0430\u0441\u044C", tone: "good" },
      { value: "mid", label: "\u0441\u0440\u0435\u0434\u043D\u0435", tone: "mid" },
      { value: "poor", label: "\u043D\u0435 \u0432\u044B\u0441\u043F\u0430\u043B\u0430\u0441\u044C", tone: "bad" }
    ]
  },
  {
    key: "movement",
    label: "\u0414\u0432\u0438\u0436\u0435\u043D\u0438\u0435",
    options: [
      { value: "little", label: "\u043C\u0430\u043B\u043E", tone: "bad" },
      { value: "normal", label: "\u043D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E", tone: "good" },
      { value: "much", label: "\u043C\u043D\u043E\u0433\u043E", tone: "mid" }
    ]
  },
  {
    key: "food",
    label: "\u041F\u0438\u0442\u0430\u043D\u0438\u0435",
    options: [
      { value: "regular", label: "\u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E", tone: "good" },
      { value: "chaotic", label: "\u0445\u0430\u043E\u0442\u0438\u0447\u043D\u043E", tone: "mid" },
      { value: "overate", label: "\u043F\u0435\u0440\u0435\u0435\u043B\u0430", tone: "bad" }
    ]
  },
  {
    key: "tension",
    label: "\u041D\u0430\u043F\u0440\u044F\u0436\u0435\u043D\u0438\u0435 \u0434\u043D\u044F",
    options: [
      { value: "low", label: "\u043D\u0438\u0437\u043A\u043E\u0435", tone: "good" },
      { value: "mid", label: "\u0441\u0440\u0435\u0434\u043D\u0435\u0435", tone: "mid" },
      { value: "high", label: "\u0432\u044B\u0441\u043E\u043A\u043E\u0435", tone: "bad" }
    ]
  },
  {
    key: "recovery",
    label: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435",
    options: [
      { value: "yes", label: "\u0431\u044B\u043B\u043E", tone: "good" },
      { value: "some", label: "\u043D\u0435\u043C\u043D\u043E\u0433\u043E", tone: "mid" },
      { value: "no", label: "\u043D\u0435 \u0431\u044B\u043B\u043E", tone: "bad" }
    ]
  }
];
var WELLBEING_MIN = 1;
var WELLBEING_MAX = 5;
var WELLBEING_LABEL = "\u0421\u0430\u043C\u043E\u0447\u0443\u0432\u0441\u0442\u0432\u0438\u0435";
var WELLBEING_LABELS = {
  1: "\u043D\u0435\u0442 \u0441\u0438\u043B",
  2: "\u0441\u043B\u0430\u0431\u043E",
  3: "\u043E\u0431\u044B\u0447\u043D\u043E",
  4: "\u0445\u043E\u0440\u043E\u0448\u043E",
  5: "\u0431\u043E\u0434\u0440\u043E"
};
var CYCLE_STATES = [
  { value: "day", label: "\u0434\u0435\u043D\u044C \u0446\u0438\u043A\u043B\u0430" },
  { value: "menstruation", label: "\u043C\u0435\u043D\u0441\u0442\u0440\u0443\u0430\u0446\u0438\u044F" },
  { value: "none", label: "\u043D\u0435\u0442 \u0446\u0438\u043A\u043B\u0430" }
];
var optionValues = (key) => {
  const field = DAY_FIELDS.find((f) => f.key === key);
  if (!field) throw new Error(`\u041D\u0435\u0442 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u044F ${key}`);
  return field.options.map((o) => o.value);
};
var dayEntryInput = z3.object({
  sleep: z3.enum(optionValues("sleep")).nullable().default(null),
  movement: z3.enum(optionValues("movement")).nullable().default(null),
  food: z3.enum(optionValues("food")).nullable().default(null),
  tension: z3.enum(optionValues("tension")).nullable().default(null),
  recovery: z3.enum(optionValues("recovery")).nullable().default(null),
  wellbeing: z3.number().int().min(WELLBEING_MIN).max(WELLBEING_MAX).nullable().default(null),
  /** Цикл — отдельная необязательная кнопка, а не седьмой обязательный пункт. */
  cycleState: z3.enum(["day", "menstruation", "none"]).nullable().default(null),
  cycleDay: z3.number().int().min(1).max(60).nullable().default(null),
  /**
   * Своими словами.
   *
   * Шесть кнопок не расскажут, что именно было: «ела много белка»,
   * «десять тысяч шагов», «сорвалась на сладкое». Необязательное поле,
   * и оно же — то, к чему женщина вернётся через три месяца.
   */
  note: z3.string().max(2e3).nullable().default(null)
});
function dayOptionLabel(fieldKey, value) {
  if (!value) return null;
  const field = DAY_FIELDS.find((f) => f.key === fieldKey);
  return field?.options.find((o) => o.value === value)?.label ?? value;
}
function dayOptionTone(fieldKey, value) {
  if (!value) return null;
  const field = DAY_FIELDS.find((f) => f.key === fieldKey);
  return field?.options.find((o) => o.value === value)?.tone ?? null;
}
var DAY_WEEK_LENGTH = 7;
function cycleLabel(state, day) {
  if (state === "menstruation") return "\u043C\u0435\u043D\u0441\u0442\u0440\u0443\u0430\u0446\u0438\u044F";
  if (state === "none") return "\u043D\u0435\u0442 \u0446\u0438\u043A\u043B\u0430";
  if (state === "day" && day !== null) return `${day}-\u0439 \u0434\u0435\u043D\u044C \u0446\u0438\u043A\u043B\u0430`;
  if (day !== null) return `${day}-\u0439 \u0434\u0435\u043D\u044C \u0446\u0438\u043A\u043B\u0430`;
  return null;
}
export {
  ANALYTICS_EVENTS,
  APP_SENT_EVENTS,
  BROADCAST_NEVER,
  CONTENT_SCHEMAS,
  CYCLE_STATES,
  DAY_FIELDS,
  DAY_WEEK_LENGTH,
  EMPTY_COHORT,
  FLOW_STATUSES,
  FLOW_STATUS_LABELS,
  FUNNEL_OUTCOMES,
  FUNNEL_STEPS,
  MORNING_CHECK_CAUTION_CHOICES,
  MORNING_CHECK_CHOICES,
  OBS7_BASELINE_SCALES,
  OBSERVATION_DAYS,
  PRIMARY_METRIC_EVENT,
  PRODUCT_CODES,
  PRODUCT_LABELS,
  PROTECTED_CONTENT_TYPES,
  SCALE_DIRECTION,
  SCALE_KEYS,
  SCREENS_WITHOUT_NAV,
  SCREEN_ALLOWED_BACK_TO,
  SCREEN_IDS,
  SCREEN_MAP,
  SCREEN_TITLES,
  SECONDARY_METRIC_EVENT,
  WELLBEING_LABEL,
  WELLBEING_LABELS,
  WELLBEING_MAX,
  WELLBEING_MIN,
  broadcastDraft,
  cardContent,
  cohortFilter,
  contentKey,
  cycleLabel,
  dayEntryInput,
  dayOptionLabel,
  dayOptionTone,
  dayTask,
  evaluateDelta,
  faqContent,
  medScreenContent,
  menuContent,
  obsDayContent,
  parseContent,
  practiceContent,
  programDayContent,
  programWeekContent,
  routeTarget,
  safeParseContent,
  safetyScreeningContent,
  screenContent,
  screenTitle
};
